import shopDetailEsc from './esc'
import shopDetailCompanyFail from './companyFail'
import shopDetailBusinessCertificate from './businessCertificate'
import shopDetailHealthyCertificate from './healthyCertificate'
import shopDetailLandUseCertificate from './landUseCertificate'
import shopDetailWineSoldCertificate from './wineSoldCertificate'

export default {
  shopDetailEsc,                    // ESC
  shopDetailCompanyFail,            // 公司公证
  shopDetailBusinessCertificate,    // 市政经营许可证
  shopDetailHealthyCertificate,     // 卫生安全通知
  shopDetailLandUseCertificate,     // 土地使用许可证
  shopDetailWineSoldCertificate     // 酒精销售许可证
}
